<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>卡密列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <!-- 醒目公告 -->
      <!-- <el-alert type="error" effect="dark" show-icon :closable="false" style="margin-top: 5px; margin-bottom: 5px;">
        <template slot="title">
          <span style="font-size: 15px; font-weight: bold;">
            📢 系统维护通知：将于 2026年8月21 日凌晨 00:00 - 01:00 进行服务器升级维护，届时不要新建卡密，部分服务可能受影响，请提前做好准备！
          </span>
        </template>
      </el-alert> -->
      <div class="navbtn">
        <el-card class="button-content">
        <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="newCreateCard" :loading="stateOver">提卡</el-button>
        <el-button type="primary" size="small" icon="el-icon-download" @click="exports">导出</el-button>
        <el-badge :value="totalStrip" class="item">
          <el-button type="primary" size="small" @click="batchOperation" class="operation">批量操作</el-button>
        </el-badge>
        <el-button type="primary" size="small" @click="batchUnbind" class="operation">批量解绑</el-button>
        <el-button type="danger" size="small" @click="clearBtn" ref="clearRef" v-show="isClear">清除所有选中</el-button>
        </el-card>
      </div>
      <!-- <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">查询子代理需要先选择软件,解绑代理将会查不到子代理卡密</el-tag> -->
      <el-form :inline="true" :model="queryInfo" class="demo-form-inline" ref="searchFormRef" size="small">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable :style="inputWidth?{width:'100%'}:{width:'300px'}" @change="findChildren" @clear="clearSoft">
            <!-- <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option> -->
            <el-option v-for="item in allSoftNameObj" :key="item.appKey" :label="item.softName" :value="item.appKey"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡类 " prop="cardName">
          <el-select v-model="queryInfo.cardName" placeholder="全部卡类" clearable :style="inputWidth?{width:'100%'}:{width:'300px'}">
            <el-option v-for="(item, index) in allCardType" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态 " prop="states">
          <el-select v-model="queryInfo.states" placeholder="所有状态" clearable :style="inputWidth?{width:'100%'}:{width:'240px'}">
            <!-- <el-option v-for="item in allState" :key="item" :label="item" :value="item"></el-option> -->
            <el-option label="未使用" value="未使用"></el-option>
            <el-option label="正常" value="正常"></el-option>
            <el-option label="过期" value="过期"></el-option>
            <el-option label="冻结" value="冻结"></el-option>
            <el-option label="已激活" value="已激活"></el-option>
            <el-option label="封禁" value="封禁"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="子代理" prop="producer" class="producer">
          <el-select v-model="queryInfo.producer" placeholder="全部" clearable :style="inputWidth?{width:'100%'}:{width:'416px'}" @change="changeInput()">
            <el-option v-for="item in agentChild" :key="item.id" :label="item.email" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡密 " prop="cardPassword">
          <el-input v-model="queryInfo.cardPassword"  clearable placeholder="支持模糊查询" :style="inputWidth?{width:'100%'}:{width:'400px'}"></el-input>
        </el-form-item>

        <el-form-item label="备注 " prop="remarks">
          <el-input v-model="queryInfo.remarks" style="width:100%" clearable placeholder="支持模糊查询" :style="inputWidth?{width:'100%'}:{width:'300px'}"></el-input>
        </el-form-item>

        <el-form-item label="激活时间 " class="lately" prop="lately" style="marginTop:1px">
          <div class="lately-div">
            <el-date-picker v-model="queryInfo.active" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :style="inputWidth?{width:'200px'}:{width:'100%'}"></el-date-picker>
          </div>
        </el-form-item>

        <el-form-item >
          <el-button type="primary" size="small" @click="query">查 询</el-button>
          <el-button size="small" @click="reSet">重 置</el-button>
        </el-form-item>
      </el-form>
      
      <el-table :data="cardTableData" border style="width: 100%" stripe ref="table" v-loading="loading" @selection-change="handleSelectionChange" row-key="_id">
        <el-table-column type="selection" :reserve-selection="true" width="55" >
        </el-table-column>
        <el-table-column prop="cardPassword" label="卡密" width="390">
        </el-table-column>
        <el-table-column prop="softName" label="所属软件" width="200">
        </el-table-column>
        <el-table-column prop="cardName" label="卡类" width="180">
        </el-table-column>
        <el-table-column prop="state" label="状态" style="width: 12%">
          <template slot-scope="scope">
            <span v-if="scope.row.freeze === true" style="color: #d80821">封禁</span>
            <span v-if="scope.row.state === '正常' && scope.row.freeze === false" style="color: #237804">{{scope.row.state}}</span>
            <span v-if="scope.row.state === '未使用' && scope.row.freeze === false" style="color: #606266">{{scope.row.state}}</span>
            <span v-if="scope.row.state === '过期' && scope.row.freeze === false" style="color: #ad6800">{{scope.row.state}}</span>
            <!-- <span v-if="scope.row.state === '冻结'" style="color: #d80821">{{scope.row.state}}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="upperLimit" label="多开" style="width: 12%">
        </el-table-column>
        <el-table-column prop="crowding" label="顶号" style="width: 12%">
          <template slot-scope="scope">
            <span v-if="scope.row.crowding === false" style="color: #d80821">否</span>
            <span v-if="scope.row.crowding === true" style="color: #237804">是</span>
          </template>
        </el-table-column>
        <el-table-column prop="unbundling" label="解绑" style="width: 12%">
          <template slot-scope="scope">
            <span v-if="scope.row.unbundling === false" style="color: #ad6800">未开启</span>
            <span v-if="scope.row.unbundling === true" style="color: #237804">是</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="生成时间" width="170"></el-table-column>
        <el-table-column prop="expireDate" label="到期时间" width="170"></el-table-column>
        <el-table-column prop="latelyDate" label="最近使用" width="170"></el-table-column>
        <el-table-column prop="activeDate" label="激活时间" width="170"></el-table-column>
        <el-table-column prop="agent" label="代理人" width="170"></el-table-column>
        <el-table-column prop="remarks" label="备注" width="170">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="130" >
          <template slot-scope="scope">
            <el-dropdown v-show="mySelf">
              <span class="el-dropdown-link" style="font-size:14px">
              快捷操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="cardPasswordLog(scope.row)">日志</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="multiTransform(scope.row)">多开转换</el-dropdown-item> -->

                <el-dropdown-item 
                  v-if="getSoftConfig(scope.row).multiTransformAdd" 
                  @click.native="multiTransformAdd(scope.row)"
                >多开转换增加</el-dropdown-item>
                
                <el-dropdown-item 
                  v-if="getSoftConfig(scope.row).multiTransformSub" 
                  @click.native="multiTransformSub(scope.row)"
                >多开转换减少</el-dropdown-item>

                <el-dropdown-item v-if="!scope.row.freeze" @click.native="freezeCard(scope.row)">封禁卡密</el-dropdown-item>
                <el-dropdown-item v-else @click.native="unfreezeCard(scope.row)">解封卡密</el-dropdown-item>
                <el-dropdown-item :style="{color:'red'}" @click.native="delCard(scope.row)">删除卡密</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>


    <!-- 删除卡密的Dialog -->
    <el-dialog title="确定要删除此卡密？" :close-on-click-modal="false" :visible.sync="delDialog" :width="diaLogWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>确定要删除此卡密？<br></span>
      </div>
      <div style="margin-left:30px;margin-bottom:20px"><span>{{thisCard.cardPassword}}</span></div>
      <span style="margin-left:30px">* 删除代理未使用卡密将返还积分</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="delDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 批量操作的Dialog -->
    <el-dialog title="批量操作卡密:" :close-on-click-modal="false" :visible.sync="batchOperationDialogVisible" :width="diaLogWidth" @close="closeBatchOperation">
      <el-form :model="batchOperationForm" :rules="batchOperationRules" ref="batchOperationFormRef" label-width="100px">
        <div>
          <el-tooltip class="item" effect="dark" placement="top">
            <span slot="content">注意: 一行一条卡密, 以回车分割</span>
            <label for="cardlengthid" >卡密列表<i class="iconfont icon-wenhaoxiao"></i></label>
          </el-tooltip>
          <el-form-item label="" prop="info" label-width="91px">
            <el-input type="textarea" v-model="batchOperationForm.info" :autosize="{ minRows: 20,maxRows: 20}"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer batch">
        <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' title="确定要删除以上卡密？(* 删除代理未使用卡密将返还积分)" @confirm="batchDel()">
          <el-button slot="reference" type="danger" size="small" :loading="state">批量删除</el-button>
        </el-popconfirm>
        <!-- <el-button slot="reference" type="danger" size="small" @click="batchDel">批量删除</el-button> -->
        <el-button type="primary" size="small" @click="batchUnfreeze" :loading="state">批量解封</el-button>
        <el-button type="primary" size="small" @click="batchFreeze" :loading="state" style="margin-left: 0">批量封禁</el-button>

        <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' title="确定要对以上卡密续费？(* 对未使用的卡密续费无效)" @confirm="batchRenew()">
          <el-button slot="reference" type="primary" size="small" :loading="state">批量续费</el-button>
        </el-popconfirm>
        
        
      </span>
    </el-dialog>

    <!-- 提卡dialog -->
    <el-dialog title="提 卡" :close-on-click-modal="false" :visible.sync="extractDialogVisible" :width="extractWidth" @close="closeExtractDiaLog">
      <el-form ref="extractFromRef" :model="extractFrom" label-width="80px" :rules="extractFromRules" class="edit-form" size="small">
        
        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="extractFrom.softName" @change="selectChange">
            <!-- <el-option :label="extractFrom.softName" :value="extractFrom.softName" ></el-option> -->
            <el-option v-for="item in allSoftNameIntegral" :key="item.appKey" :label="item.name" :value="item.name + '_' + item.appKey" ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡类" prop="type">
          <el-select v-model="extractFrom.type" placeholder="请选择卡类" @change="selectCardType">
            <el-option v-for="item in cardTypePrice" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="生成数量" prop="generateNum">
          <el-input-number v-model="extractFrom.generateNum" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="extractFrom.remarks" :autosize="{ minRows: 1, maxRows: 4}" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>

        <el-form-item label="" prop="configure" label-width="22px" v-if="activeSoftName.customUpperLimit">
          <div class="custom">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">是否自定义 卡密前缀、顶号登录、多<br/>开上限 参数，它们默认是继承至所属<br/>软件</div>
              <label for="customid" style="margin-left:-18px">自定义<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="customid" style="display: block" v-model="extractFrom.custom" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="多开上限" prop="upperLimit" v-show="extractFrom.custom">
          <el-input-number v-model="extractFrom.customUpperLimitNum" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>
        <el-tag size="small" type="danger" style="margin-bottom:5px;color:red;float:right;">消耗{{numIntegral}}积分</el-tag>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="extractBtn" :loading="state">创 建</el-button>
      </span>
    </el-dialog>

    <!-- 复制并关闭Dialog -->
    <el-dialog title="确定要删除此卡密？" :close-on-click-modal="false" :visible.sync="copyDialog" :width="copyWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-chenggong"></use>
          </svg>成功生成 {{many}} 张卡密
        </span>
      </div>
      <div ><span>{{thisCard.cardPassword}}</span></div>
      <el-form ref="copyFromRef" :model="copyFrom"  :rules="copyFromRules" >
        <el-form-item label="" prop="info" >
          <el-input type="textarea" v-model="copyFrom.cardResult" :autosize="{ minRows: 10,maxRows: 100}"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary"  size="small" :loading="state" v-clipboard:copy="copyFrom.cardResult" v-clipboard:success="onCopy">复制&关闭</el-button>
      </span>
    </el-dialog>

    <!-- 卡密日志Dialog -->
    <el-dialog :title="cardTitle" :close-on-click-modal="false" :visible.sync="cardPassworddialog" :width="cardDialogWidth">
      <div class="card-log">
        <el-card>
          <el-button size="small" type="primary" icon="el-icon-refresh" circle @click="cardRefresh" :loading="state" class="cardrefresh"></el-button>
          <el-badge :value="totalOnline" class="item">
            <el-popover placement="top-start"  :width="popoverWidth" trigger="hover">
              <div style="margin-bottom:10px;margin-left:10px">
                序号 : <el-tag size="small">设备号</el-tag> : <el-tag  size="small" >token</el-tag> : <el-tag size="small" type="success" effect="dark">心跳time</el-tag>
              </div>
              <div class="popover-scroll-container">
                <div v-for="(item, index) in online" :key="item.token" style="margin-bottom:10px;margin-left:10px">
                  {{index+1}} : <el-tag size="small">{{item.split(":")[0]}}</el-tag> : <el-tag  size="small" >{{item.split(":")[1]}}</el-tag> : <el-tag class="time" size="small" type="success" effect="dark">{{timestampToTime(parseInt(item.split(":")[2])).substring(timestampToTime(parseInt(item.split(":")[2])).length - 8)}}</el-tag> 
                </div>
              </div>
              <el-button slot="reference" size="small" :loading="state">当前在线</el-button>
            </el-popover>
          </el-badge>
        </el-card>
      </div>
      <el-table :data="cardData" border style="width: 100%" stripe>
        <el-table-column prop="action" label="动作" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.action === '登录'" style="color: #237804">登录</span>
            <span v-if="scope.row.action === '退出登录'" style="color: #0050b3">退出登录</span>
            <span v-if="scope.row.action === '解绑'" style="color: #ad6800">解绑</span>
            <span v-if="scope.row.action === '冻结'" style="color: #db0d0d">冻结</span>
            <span v-if="scope.row.action === '充值'" style="color: #db0d0d">充值</span>
            <span v-if="scope.row.action === '时间转移'" style="color: #db0d0d">时间转移</span>
            <span v-if="scope.row.action === '邀请充值'" style="color: #db0d0d">邀请充值</span>
            <span v-if="scope.row.action === '赠送'" style="color: #d48806">赠送</span>
            <span v-if="scope.row.action === '多开转换'" style="color: #08979c">多开转换</span>
          </template>
        </el-table-column>
        <el-table-column prop="sign" label="记录" >
          
          <template slot-scope="scope">
            <el-popover placement="top-start" trigger="hover" popper-class="my-popover">
              <code>
                <div v-if="Array.isArray(scope.row.sign)">
                  <span class="code-span" v-for="item in scope.row.sign" :key="item" style="margin-left:20px;margin-right:20px">{{item}}</span>
                </div>
                <div v-if="Object.prototype.toString.call(scope.row.sign) === '[object Object]'">
                  <span class="code-span">{</span>
                  <span class="code-span" v-for="(item,index) in scope.row.sign" :key="index" style="margin-left:20px;margin-right:20px">{{index}}: {{item}}</span>
                  <span class="code-span">}</span>
                </div>
                <div v-if="typeof(scope.row.sign)=='string'">
                  <span class="code-span" style="margin-left:20px;margin-right:20px">{{scope.row.sign}}</span>
                </div>
              </code>
              <div class="text-record" slot="reference" v-if="scope.row.sign">{{ scope.row.sign | capitalize }}</div>
            </el-popover>
          </template>
        
        </el-table-column>
        <el-table-column prop="ip" label="ip"  width="200">

          <template slot-scope="scope">
            <el-popover placement="top-start" width="200" trigger="hover"  popper-class="my-popover" @hide="closepopo" @show="showpopo(scope.row.ip)">
              <!-- <span class="code-span" v-for="(item,index) in ip" :key="index" style="margin-left:20px">{{index}}: {{item}},</span> -->
              <code>{{ip}}</code>
              <span style="color: #1890ff" slot="reference">{{ scope.row.ip }}</span>
            </el-popover>
          </template>

        </el-table-column>
        <el-table-column prop="createDate" label="时间" width="170"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="onlineHandleSizeChange"
        @current-change="onlineHandleCurrentChange"
        :current-page="onlineQueryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="onlineQueryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="onlineTotal"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="cardPassworddialog = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 多开转换弹窗 -->
    <el-dialog title="多开转换" :visible.sync="multiTransformDialogVisible" width="500px">
      <el-form :model="form" label-width="100px" v-if="currentRow">
        <el-form-item label="卡密：">
          <span>{{ currentRow.cardPassword }}</span>
        </el-form-item>
        <el-form-item label="多开上限：">
          <!-- Element UI 计数器组件 -->
          <el-input-number 
            size="mini"
            v-model="form.upperLimit" 
            :min="1" 
            :max="100" 
            @change="handleUpperLimitChange">
          </el-input-number>
        </el-form-item>
        <!-- 新增：显示剩余时间（小时数/天数） -->
        <el-form-item label="剩余时间：">
          <span style="color: #E6A23C; font-weight: bold;">{{ computedRemainingText }}</span>
        </el-form-item>
        <el-form-item label="转换后到期：">
          <span style="color: #F56C6C; font-weight: bold;">{{ computedExpireDate }}</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="multiTransformDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmTransform">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 多开转换增加弹窗 -->
    <el-dialog title="多开转换增加" :visible.sync="multiTransformAddDialogVisible" width="500px">
      <el-form :model="form" label-width="100px" v-if="currentRow">
        <el-form-item label="卡密：">
          <span>{{ currentRow.cardPassword }}</span>
        </el-form-item>
        <el-form-item label="多开上限：">
          <!-- Element UI 计数器组件 -->
          <el-input-number 
            key="add-number-input"
            class="hide-sub"
            size="mini"
            v-model="form.AddUpperLimit" 
            :min="currentRow && currentRow.upperLimit ? currentRow.upperLimit : 1"
            :max="100" 
            @change="handleUpperLimitChangeAdd">
          </el-input-number>
        </el-form-item>
        <!-- 新增：显示剩余时间（小时数/天数） -->
        <el-form-item label="剩余时间：">
          <span style="color: #E6A23C; font-weight: bold;">{{ computedRemainingText }}</span>
        </el-form-item>
        <el-form-item label="转换后到期：">
          <span style="color: #F56C6C; font-weight: bold;">{{ computedExpireDate }}</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="multiTransformAddDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmTransformAdd">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 多开转换减少弹窗 -->
    <el-dialog title="多开转换减少" :visible.sync="multiTransformSubDialogVisible" width="500px">
      <el-form :model="form" label-width="100px" v-if="currentRow">
        <el-form-item label="卡密：">
          <span>{{ currentRow.cardPassword }}</span>
        </el-form-item>
        <el-form-item label="多开上限：">
          <!-- Element UI 计数器组件 -->
          <el-input-number 
            key="sub-number-input"
            class="only-minus-right"
            size="mini"
            v-model="form.SubUpperLimit" 
            :min="1"
            :max="currentRow && currentRow.upperLimit ? currentRow.upperLimit : 1"
            @change="handleUpperLimitChangeSub">
          </el-input-number>
        </el-form-item>
        <!-- 新增：显示剩余时间（小时数/天数） -->
        <el-form-item label="剩余时间：">
          <span style="color: #E6A23C; font-weight: bold;">{{ computedRemainingText }}</span>
        </el-form-item>
        <el-form-item label="转换后到期：">
          <span style="color: #F56C6C; font-weight: bold;">{{ computedExpireDate }}</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="multiTransformSubDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmTransformSub">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    let checkPrefix = (rule,value,cb) => {
      const regPrefix = /^[\d\w]+$/
      if(regPrefix.test(value) || value.length === 0){
        return cb()
      }
      cb(new Error('不能超过5个字符! 只能是字母、数字的组合!'))
    }
    let textarea = (rule,value,cb) => {
      value = value.split('\n')
      const regPrefix = /^[\d\w]+$/
      if(regPrefix.test(value) || value.length <= 100){
        return cb()
      }
      cb(new Error('不能超过100条! 只能是字母、数字的组合!'))
    }
    return{
      cardTableData: [],
      total:0,
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
        softName: "",
        cardName: "",
        generateNum: 1,
        remarks: "",
        configure: "",
        custom: false,
        prefix: "",
        upperLimit: "",
        crowding: false,
        states:"",
        producer:"",
        cardPassword:"",
        remarks:"",
        lately:""
      },
      loading: false,
      state: false,
      stateOver:false,
      createCardDiaLog:false,
      createCardForm:{
        softName: "",
        cardName: "",
        generateNum: 1,
        remarks: "",
        configure: "",
        custom: false,
        prefix: "",
        upperLimit: "",
        crowding: false,
        email: this.$store.state.account,
        states:"",
        producer:"",
        cardPassword:"",
        remarks:"",
      },
      rules:{
        softName:[
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        cardName:[
          { required: true, message: "请选择卡类!", trigger: ["blur", "change"] },
        ],
        remarks:[
          { min: 0,max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ],
        configure:[
          { min: 0,max: 512,message: "不能超过512个字符!",trigger: ["blur", "change"]},
        ],
        prefix:[
          { min: 0,max: 5,message: "不能超过5个字符",trigger: ["blur", "change"]},
          { validator: checkPrefix, trigger:'blur'}
        ]
      },
      email:this.$store.state.account,
      //此人的所有软件名
      allSoftName:[],
      allCardType:[],
      diaLogWidth:'500px',
      //删除卡密的dialog
      thisCard:"",
      delDialog:false,

      //批量操作的dialog
      batchOperationDialogVisible:false,
      totalStrip:"",
      cardTableArr:[],
      //批量操作卡密列表表单
      batchOperationForm:{
        info:"",
      },
      batchOperationRules:{
        info:[
          { required: true, message: "批量操作最多同时处理100张卡密!", trigger: ["blur", "change"] },
          { validator:textarea,trigger:'blur'}
        ]
      },

      isClear:false,
      inputWidth:false,
      allState: ['未使用','正常','已过期','已冻结','已使用'],
      producer: [],

      //'编辑卡密对话框
      editDiaLogVisible:false,
      editFrom:{},
      titleCard:"",
      editFromRules:{
        dateTime:''
      },
      inputVisible: false,
      inputValue: '',
      editDialogWidth:'40%',

      extractDialogVisible:false,
      extractFrom:{
        generateNum:1,
        customUpperLimitNum: 1,
        custom: false
      },
      extractFromRules:{
        softName:[
          { required: true, message: "请选择软件", trigger: ["blur", "change"] },
        ],
        type:[
          { required: true, message: "请选择卡类", trigger: ["blur", "change"] },
        ],
        remarks:[
          { min: 0,max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ],
      },
      allSoftNameIntegral:[],
      allSoftNameObj:[],
      appKey:"",
      cardTypePrice:"",
      extractWidth:"500px",



      copyWidth:'600px',
      copyDialog:false,
      cardResult:[],
      copyFromRef:{},
      copyFromRules:{},
      copyFrom:{},
      many:0,

      cardPassworddialog: false,
      cardTitle:"",
      cardDialogWidth:'1000px',
      popoverWidth:'560',
      cardData:[],
      ip: '',
      totalOnline: '',
      online: [],
      onlineQueryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account
      },
      onlineTotal: 0,
      onlineIndex: "",
      importDialog: false,
      importWidth: "600px",
      file:{},

      activeSoftName:{},
      agentChild:[],
      mySelf: true,
      selectIntegral:0,
      visible: false,
      num4:1,

      lastId: null,
      firstId: null,

      multiTransformDialogVisible: false,
      currentRow: null,
      baseTotalMs: 0,            // 基础总毫秒数（用时间戳计算更精准）
      form: {
        AddUpperLimit: 1,
        SubUpperLimit: 1,
        upperLimit: 1
      },
      computedExpireDate: '',    // 界面显示的格式化日期
      rawComputedExpireTimestamp: 0, // 提交用的计算后时间戳
      computedRemainingText: '',    // 实时计算的剩余时间文本（包含小时）

      multiTransformAddDialogVisible: false,
      multiTransformSubDialogVisible: false,
    }
  },
  computed:{
    allTotal(){
      return this.batchOperationForm.info.split('\n').length
    },
    numIntegral () {
      //生成数量 * 1卡密卡密消耗积分 * 多开数量
      return this.extractFrom.generateNum * this.selectIntegral * this.extractFrom.customUpperLimitNum
    }
  },
  created(){
    this.getCardPassword()
    this.$nextTick(()=>{
      if (this.isMobile()) {
        this.diaLogWidth = '100%'
        this.inputWidth = true
        this.editDialogWidth = '100%'
        this.extractWidth = '100%'
        this.cardDialogWidth = '100%'
      }
    })
    this.getCardTypeSoftName()
    // this.getChildAgent()
    this.findChildren()
  },
  methods:{
    async showpopo(val){
      console.log('显示时候触发',val);
      let result = window.localStorage.getItem(val)
      if(!result){
        this.state = true
        result = await this.$http.post('getIp',{ip:val})
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          return this.$notify.error({title: '获取失败',message:result.data.meta.msg});
        }
        result = result.data.data
        window.localStorage.setItem(val, JSON.stringify(result))
      }
      this.ip = result
    },
    query(){
      //this.queryInfo.lately = ""
      this.getCardPassword(1)
    },
    //刷新按钮
    refresh(){
      this.getCardPassword()
    },
    reSet(){
      this.queryInfo.active = ""
      this.$refs.searchFormRef.resetFields()
      this.getCardPassword(1)
      // this.clearSoft()
      this.findChildren()
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // localStorage.setItem('isiphone',flag)
      //console.log(flag)
      return flag;
    },
    
    selectCardType(val){
      console.log("val:",val);
      let start = val.indexOf("[")
      let end = val.indexOf("]")
      let str = val.slice(start, end + 1)
      console.log("str=",str);
      this.selectIntegral = str.replace(/[^\d]/g, "");
      // console.log("this.selectIntegral:",this.selectIntegral);
    },
    async getCardTypeSoftName(){
      this.stateOver = true
      //const result = await this.$http.post("cardGetSoft", {email:this.email});
      //const result = await this.$http.post("cardGetSoft", {email:this.email});
      console.log('---------------');
      const result = await this.$http.get("getcardsoftlist",{
        params:this.queryInfo
      });
      this.stateOver = false
      console.log('getresult',result);
      this.allSoftNameObj = result.data.data.result
      console.log("this.allSoftNameObj=",this.allSoftNameObj);
      this.allSoftName = result.data.data.result.map(element => {
        //console.log('result',element.softName);
        return element.softName
      })
      this.allCardType = result.data.data.resolve.map(element => {
        console.log('resolve-->',element.cardName);
        return element.cardName
      })
      console.log("this.allCardType:",this.allCardType);
      this.allSoftNameIntegral = result.data.data.result.map(element => {
        // console.log(element.softName+' - '+`[ 积分余额:${element.integral} ]`);
        //return element.softName+' - '+`[ 积分余额:${element.integral} ]`
        return {name: element.softName+' - '+`[ 积分余额:${element.integral} ]`, appKey: element.appKey}
      })
      console.log("this.allSoftNameIntegral=",this.allSoftNameIntegral);
    },
    async getChildAgent(){
      const result = await this.$http.post("getChildAgent", {email:this.$store.state.account});
      // console.log('getChildAgent',result);
      this.agentChild = result.data.data.map(element =>{
        return element.agentEmail
      })
    },
    /*
    async getCardPassword(index){
      this.state = true
      //console.log(this.queryInfo);
      if(index){
        this.queryInfo.pagenum = 1
      }
      // const result = await this.$http.get("getagentpassword", {
      //   params:this.queryInfo
      // });
      console.log("this.queryInfo:",this.queryInfo);
      // this.queryInfo.producer = this.queryInfo.id
      const result = await this.$http.post("getagentpassword",this.queryInfo)
      console.log('result',result.data.data);
      this.state = false
      this.clearBtn()
      if(!result.data.data.total){
        this.total = 0
        this.cardTableData = []
        return
      }
      this.total = result.data.data.total
      console.log("total:",this.total);
      //this.cardTableData = result.data.data.data
      this.cardTableData = result.data.data.data.map(element =>{
        if(element.createDate){
          element.createDate = this.timestampToTime(parseInt(element.createDate))
        }
        if(element.expireDate){
          element.expireDate = this.timestampToTime(parseInt(element.expireDate))
        }
        if(element.latelyDate){
          element.latelyDate = this.timestampToTime(parseInt(element.latelyDate))
        }
        if(element.activeDate){
          element.activeDate = this.timestampToTime(parseInt(element.activeDate))
        }

        if (element.producer != this.$store.state.account) {
          this.mySelf = false;
        }else{
          this.mySelf = true
        }
        //console.log(element.agent);
        if(this.producer.indexOf(element.producer) === -1){//搜到了
          this.producer.push(element.producer)
        }
        return element
      })
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getCardPassword()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getCardPassword()
    },
    */
    async getCardPassword(index){
      this.state = true
      this.loading = true
      //console.log(this.queryInfo);
      if(index){
        this.queryInfo.pagenum = 1
        this.lastId = null;
        this.firstId = null;
      }
      // const result = await this.$http.get("getagentpassword", {
      //   params:this.queryInfo
      // });
      this.queryInfo.lastId = this.lastId;
      this.queryInfo.firstId = this.firstId;
      console.log("this.queryInfo:",this.queryInfo);
      // this.queryInfo.producer = this.queryInfo.id
      const result = await this.$http.post("getagentpassword",this.queryInfo)
      console.log('result',result.data.data);
      
      this.clearBtn()
      if(!result.data.data.total){
        this.total = 0
        this.cardTableData = []
        this.state = false
        this.loading = false
        return
      }
      this.total = result.data.data.total
      console.log("total:",this.total);
      const originalData = result.data.data.data || [];
      // 数据加载后，更新 firstId 和 lastId（降序排序下，数组第0项是最大 _id，最后一项是最小 _id）
      if (originalData.length > 0) {
        this.firstId = originalData[0]._id; // 当前页最大 _id
        this.lastId = originalData[originalData.length - 1]._id; // 当前页最小 _id
        console.log("更新游标：", { firstId: this.firstId, lastId: this.lastId });
      }
      //this.cardTableData = result.data.data.data
      this.cardTableData = result.data.data.data.map(element =>{
        if(element.createDate){
          element.createDate = this.timestampToTime(parseInt(element.createDate))
        }
        if(element.expireDate){
          element.expireDate = this.timestampToTime(parseInt(element.expireDate))
        }
        if(element.latelyDate){
          element.latelyDate = this.timestampToTime(parseInt(element.latelyDate))
        }
        if(element.activeDate){
          element.activeDate = this.timestampToTime(parseInt(element.activeDate))
        }

        if (element.producer != this.$store.state.account) {
          this.mySelf = false;
        }else{
          this.mySelf = true
        }
        //console.log(element.agent);
        if(this.producer.indexOf(element.producer) === -1){//搜到了
          this.producer.push(element.producer)
        }
        return element
      })
      this.state = false
      this.loading = false
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val;
      this.queryInfo.pagenum = 1;
      this.firstId = null;
      this.lastId = null;
      this.getCardPassword()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      if(val === this.queryInfo.pagenum){
        this.refresh()
        return
      }
      // ===== 核心：判断是否是跳页（非相邻页码）=====
      const oldPage = this.queryInfo.pagenum; // 原页码
      console.log(`oldPage=${oldPage} val=${val}`);
      if(val == (this.queryInfo.pagenum + 1)){
        this.firstId = null;
        console.log("----前翻页");
      }else if(val == (this.queryInfo.pagenum - 1)){
        this.lastId = null;
        console.log("----后翻页");
      }else{
        this.firstId = null;
        this.lastId = null;
        console.log("--------");
      }
      this.queryInfo.pagenum = val
      this.getCardPassword()
    },
    //表格选中
    handleSelectionChange(val) {
      this.cardTableArr = val
      this.totalStrip = this.cardTableArr.length
      console.log('cardTableArr',this.cardTableArr);
      this.isClear = true
      if(this.cardTableArr.length === 0){
        this.totalStrip = ""
        this.isClear = false
      }
    },
    //点击清除所有
    clearBtn(){
      this.cardTableArr = []
      this.$refs.table.clearSelection()
      this.batchOperationForm.info = ""
    },

    closepopo() {
      this.batchOperationForm.info = ""
      // console.log("this.$refs.batchOperationFormRef=",this.$refs.batchOperationFormRef);
      // this.$refs.batchOperationFormRef.resetFields()
    },
    closeBatchOperation(){
      this.$refs.batchOperationFormRef.resetFields()
    },
    //批量操作的点击事件
    batchOperation(){
      this.batchOperationForm.info = ""
      this.batchOperationDialogVisible = true
      this.batchOperationForm.info = this.batchOperationForm.info.split('...')
      this.cardTableArr.forEach(element => {
        this.batchOperationForm.info.push(element.cardPassword)
      });
      this.batchOperationForm.info = this.batchOperationForm.info.toString()
      this.batchOperationForm.info = this.batchOperationForm.info.replace(/,/g,"\n").trim()
      console.log('info',this.batchOperationForm.info);
    },
    
    
    //创建卡密
    createCard(){
      this.$refs.createCardFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        console.log(this.createCardForm);
        this.createCardForm.producer = this.$store.state.account
        const result = await this.$http.post('createCard',this.createCardForm)
        console.log(result);
        this.state = false
        this.createCardDiaLog =false
        console.log('......');
        this.getCardPassword()
        console.log('======');
        this.many = result.data.data.length
        this.copyFrom.cardResult = result.data.data.map(element =>{
          return element.cardPassword
        })
        this.copyFrom.cardResult = this.copyFrom.cardResult.join('\n')
        //this.cardResult = result.data.data.map
        console.log('this.cardResult',this.copyFrom.cardResult);
        //console.log('生成数量:',result.data.data.length);
        this.copyDialog = true
        console.log('-------------');
        this.$refs.createCardFormRef.resetFields()
      })
    },
    
    
    delCard(value){
      console.log(value);
      this.thisCard = value
      this.delDialog = true
    },
    //删除单个卡密
    async delDialogBtn(){
      if (this.thisCard.producer != this.$store.state.account) {
        this.$notify.error({title: '错误',message:"不能操作不属于自己的卡密"});
        return
      }
      this.stateOver = true
      
      this.thisCard.email = this.$store.state.account,
      console.log('this.thisCard',this.thisCard);
      const result = await this.$http.post("subDelCard", this.thisCard);
      this.stateOver = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getCardPassword()
      this.getCardTypeSoftName()
      this.delDialog = false
    },
    //冻结卡密
    async freezeCard(value){
      console.log(value);
      if (value.producer != this.$store.state.account) {
        this.$notify.error({title: '错误',message:"不能操作不属于自己的卡密"});
        return
      }
      const result = await this.$http.post("freezeCard", value);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getCardPassword()
    },
    //解冻卡密
    async unfreezeCard(value){
      if (value.producer != this.$store.state.account) {
        this.$notify.error({title: '错误',message:"不能操作不属于自己的卡密"});
        return
      }
      const result = await this.$http.post("unfreezeCard", value);
      console.log(result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getCardPassword()
    },
    // 点击下拉菜单触发
    multiTransform(val) {
      console.log("多开转换val=", val);
      if(!val.expireDate){
        this.$notify.error({title: '错误',message: "未使用卡密不能多开转换"});
        return
      }
      if (val.freeze) {
        this.$notify.error({title: '错误',message: "封禁卡密不能多开转换"});
        return
      }
      if (val.freezeTime){
        this.$notify.error({title: '错误',message: "冻结时间卡密不能多开转换"});
        return
      }
      this.currentRow = val;
      this.form.upperLimit = val.upperLimit || 1;  
      // 兼容处理：将 "YYYY-MM-DD HH:mm:ss" 转换为 "YYYY/MM/DD HH:mm:ss" 以确保 new Date() 跨浏览器正常
      const expireStr = val.expireDate ? val.expireDate.replace(/-/g, '/') : '';
      const expireTime = new Date(expireStr).getTime();
      const now = new Date().getTime();
      if (expireTime <= now){
        this.$notify.error({title: '错误',message: "卡密过期不能多开转换"});
        return
      }
      const remainingMs = expireTime - now;
      const safeRemainingMs = remainingMs > 0 ? remainingMs : 0;
      // 1. 计算“总资源毫秒数” (例如: 剩余毫秒数 * 当前多开上限)
      const currentUpperLimit = val.upperLimit || 1;
      this.baseTotalMs = safeRemainingMs * currentUpperLimit;
      // 2. 初始化显示当前到期时间
      this.computedExpireDate = val.expireDate;
      this.rawComputedExpireTimestamp = expireTime;
      console.log("computedExpireDate=",this.computedExpireDate);
      console.log("rawComputedExpireTimestamp=",this.rawComputedExpireTimestamp);
      // 计算并显示剩余时间文本
      this.updateRemainingText(expireTime);
      // 3. 打开弹窗
      this.multiTransformDialogVisible = true;
    },
    // 监听 InputNumber 计数器改变
    handleUpperLimitChange(currentValue, oldValue) {
      console.log("oldValue=", oldValue);
      console.log("currentValue=", currentValue);
      console.log("this.rawComputedExpireTimestamp=",this.rawComputedExpireTimestamp);
      if (!this.rawComputedExpireTimestamp) return;
      const now = new Date().getTime();
      // 1. 获取当前还剩余的毫秒数 (基于上一次计算好的过期时间戳 - 当前时间戳)
      const currentRemainingMs = this.rawComputedExpireTimestamp - now;
      console.log("currentRemainingMs=",currentRemainingMs);
      if (currentRemainingMs <= 0){
        this.$notify.error({title: '错误', message:"过期卡密不能转换"});
        return;
      } 
      // 2. 核心转换公式：新的剩余毫秒数 = 当前的剩余毫秒数 * 旧的多开上限 / 新的多开上限
      const newRemainingMs = (currentRemainingMs * oldValue) / currentValue;
      // 3. 计算出新的过期时间戳 = 当前时间 + 新的剩余毫秒数
      const newExpireTime = now + newRemainingMs;
      // 4. 缓存提交需要的时间戳
      this.rawComputedExpireTimestamp = Math.floor(newExpireTime);
      console.log("监听 InputNumber rawComputedExpireTimestamp=", this.rawComputedExpireTimestamp);
      // 5. 格式化给前端展示
      this.computedExpireDate = this.timestampToTime(this.rawComputedExpireTimestamp);
      console.log("监听 InputNumber computedExpireDate=", this.computedExpireDate);
      // 6. 更新剩余时间文本（包含小时）
      this.updateRemainingText(this.rawComputedExpireTimestamp);
    },
    // 辅助函数：根据目标时间戳计算剩余的“天数和小时数”或“总小时数”
    updateRemainingText(expireTimestamp) {
      const now = new Date().getTime();
      const diffMs = expireTimestamp - now;
      if (diffMs <= 0) {
        this.computedRemainingText = "已过期 (0 小时)";
        return;
      }
      this.computedRemainingText =`剩余约:${Math.floor(diffMs / (1000 * 60 * 60))}小时`; // 总剩余小时数
    },
    async confirmTransform(){
      try {
        const params = {
          cardPassword: this.currentRow.cardPassword,
          upperLimit: this.form.upperLimit,
        };
        console.log("提交多开转换参数：", params);
        
        // 模拟调用后端 API
        const result = await this.$http.post('/agentmultitransform', params);
        console.log("转换result=",result);
        console.log("result.data.meta.status=",result.data.meta.status);
        if(result.data.meta.status == 200){
          console.log("成功");
          this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
          console.log("1111");
          this.multiTransformDialogVisible = false;
          // 刷新表格数据
          this.getCardPassword(); 
        }else{
          console.log("失败");
          this.$notify.error({title: '多开转换失败',message:result.data.meta.msg});
        }
      } catch (error) {
        console.log("error=",error);
        this.$notify.error({title: '多开转换失败：',error});
      }
    },
    getSoftConfig(row) {
      if (!this.allSoftNameObj || !Array.isArray(this.allSoftNameObj)) return {};
      // 优先通过 appKey 匹配；如果没有 appKey 字段，可改为 element.softName === row.softName
      return this.allSoftNameObj.find(item => item.softName === row.softName) || {};
    },
    multiTransformAdd(row) {
      console.log('多开转换增加', row);
      if(!row.expireDate){
        this.$notify.error({title: '错误',message: "未使用卡密不能多开转换"});
        return
      }
      if (row.freeze) {
        this.$notify.error({title: '错误',message: "封禁卡密不能多开转换"});
        return
      }
      if (row.freezeTime){
        this.$notify.error({title: '错误',message: "冻结时间卡密不能多开转换"});
        return
      }
      this.currentRow = row;
      // 关键设置：当前原上限
      const currentUpperLimit = row.upperLimit || 1;
      // 设置默认增加后的值（只能增大的最小值，即当前上限 + 1）
      this.form.AddUpperLimit = currentUpperLimit; 
      // 兼容处理：将 "YYYY-MM-DD HH:mm:ss" 转换为 "YYYY/MM/DD HH:mm:ss"
      const expireStr = row.expireDate ? row.expireDate.replace(/-/g, '/') : '';
      const expireTime = new Date(expireStr).getTime();
      const now = new Date().getTime();
      if (expireTime <= now){
        this.$notify.error({title: '错误',message: "卡密过期不能多开转换"});
        return
      }
      const remainingMs = expireTime - now;
      const safeRemainingMs = remainingMs > 0 ? remainingMs : 0;
      // 1. 计算“总资源毫秒数” (剩余毫秒数 * 当前多开上限)
      this.baseTotalMs = safeRemainingMs * currentUpperLimit;
      // 2. 根据初始增加后的 this.form.AddUpperLimit 重新计算转换后的到期时间及文本
      this.handleUpperLimitChangeAdd(this.form.AddUpperLimit);
      // 3. 打开弹窗
      this.multiTransformAddDialogVisible = true
    },
    handleUpperLimitChangeAdd(newVal) {
      console.log("handleUpperLimitChangeAdd=");
      const currentLimit = this.currentRow ? (this.currentRow.upperLimit || 1) : 1;
      
      // 如果输入值小于当前上限，直接还原为当前上限
      if (!newVal || newVal < currentLimit) {
        this.form.AddUpperLimit = currentLimit;
        newVal = currentLimit;
        this.$message.warning(`多开数量不能小于当前数量 (${currentLimit})`);
      }
      
      // 根据新的上限重新计算折算后的到期时间
      const now = new Date().getTime();
      const newRemainingMs = this.baseTotalMs / newVal;
      const newExpireTime = Math.floor(now + newRemainingMs);
      
      this.rawComputedExpireTimestamp = newExpireTime;
      this.computedExpireDate = this.timestampToTime(new Date(newExpireTime));
      this.updateRemainingText(newExpireTime);
    },
    async confirmTransformAdd(){
      try {
        const params = {
          cardPassword: this.currentRow.cardPassword,
          upperLimit: this.form.AddUpperLimit,
        };
        console.log("提交多开转换参数：", params);
        
        // 模拟调用后端 API
        const result = await this.$http.post('/agentmultitransformadd', params);
        console.log("转换result=",result);
        console.log("result.data.meta.status=",result.data.meta.status);
        if(result.data.meta.status == 200){
          console.log("成功");
          this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
          console.log("1111");
          this.multiTransformAddDialogVisible = false;
          // 刷新表格数据
          this.getCardPassword(); 
        }else{
          console.log("失败");
          this.$notify.error({title: '多开转换失败',message:result.data.meta.msg});
        }
      } catch (error) {
        console.log("error=",error);
        this.$notify.error({title: '多开转换失败：',error});
      }
    },
    // 多开转换减少回调函数
    multiTransformSub(row) {
      console.log('多开转换减少', row);
      if(!row.expireDate){
        this.$notify.error({title: '错误',message: "未使用卡密不能多开转换"});
        return
      }
      if (row.freeze) {
        this.$notify.error({title: '错误',message: "封禁卡密不能多开转换"});
        return
      }
      if (row.freezeTime){
        this.$notify.error({title: '错误',message: "冻结时间卡密不能多开转换"});
        return
      }
      
      // 校验当前上限是否已经为 1，如果是 1 则无法再减少
      const currentUpperLimit = row.upperLimit || 1;
      if (currentUpperLimit <= 1) {
        this.$notify.error({title: '错误', message: "当前多开上限已为 1，无法再减少"});
        return;
      }

      this.currentRow = row;
      this.form.SubUpperLimit = currentUpperLimit; // 初始值为当前上限
      
      // 兼容处理：转换为 "YYYY/MM/DD HH:mm:ss"
      const expireStr = row.expireDate ? row.expireDate.replace(/-/g, '/') : '';
      const expireTime = new Date(expireStr).getTime();
      const now = new Date().getTime();
      if (expireTime <= now){
        this.$notify.error({title: '错误',message: "卡密过期不能多开转换"});
        return
      }
      const remainingMs = expireTime - now;
      const safeRemainingMs = remainingMs > 0 ? remainingMs : 0;
      
      // 1. 计算“总资源毫秒数”
      this.baseTotalMs = safeRemainingMs * currentUpperLimit;
      
      // 2. 初始化显示当前到期时间与文本
      this.handleUpperLimitChangeSub(this.form.SubUpperLimit);
      this.multiTransformSubDialogVisible = true;
    },
    // 数值变更监听
    handleUpperLimitChangeSub(newVal) {
      console.log("handleUpperLimitChangeSub=");
      const currentLimit = this.currentRow ? (this.currentRow.upperLimit || 1) : 1;
      
      // 限制只能变小：如果大于当前上限，重置为当前上限
      if (newVal > currentLimit) {
        this.form.SubUpperLimit = currentLimit;
        newVal = currentLimit;
        this.$message.warning(`多开数量不能大于当前数量 (${currentLimit})`);
      }
      
      // 限制最小值不能小于 1
      if (!newVal || newVal < 1) {
        this.form.SubUpperLimit = 1;
        newVal = 1;
        this.$message.warning('多开数量最小不能小于 1');
      }
      
      // 根据新的上限重新计算折算后的到期时间
      const now = new Date().getTime();
      const newRemainingMs = this.baseTotalMs / newVal;
      const newExpireTime = Math.floor(now + newRemainingMs);
      
      this.rawComputedExpireTimestamp = newExpireTime;
      this.computedExpireDate = this.timestampToTime(new Date(newExpireTime));
      this.updateRemainingText(newExpireTime);
    },
    async confirmTransformSub(){
      try {
        const params = {
          cardPassword: this.currentRow.cardPassword,
          upperLimit: this.form.SubUpperLimit,
        };
        console.log("提交多开转换参数：", params);
        
        // 模拟调用后端 API
        const result = await this.$http.post('/agentmultitransformsub', params);
        console.log("转换result=",result);
        console.log("result.data.meta.status=",result.data.meta.status);
        if(result.data.meta.status == 200){
          console.log("成功");
          this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
          console.log("1111");
          this.multiTransformSubDialogVisible = false;
          // 刷新表格数据
          this.getCardPassword(); 
        }else{
          console.log("失败");
          this.$notify.error({title: '多开转换失败',message:result.data.meta.msg});
        }
      } catch (error) {
        console.log("error=",error);
        this.$notify.error({title: '多开转换失败：',error});
      }
    },
    //批量删除
    batchDel(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        if (this.batchOperationForm.info.indexOf("*") > -1) {
          this.$notify.error({title: '错误',message:"不能操作不属于自己的卡密"});
          return
        }
        this.state = true
        //老的批量删除
        const result = await this.$http.post('subDelManyCard',this.batchOperationForm)
        //新的批量删除
        // console.log("this.cardTableArr:",this.cardTableArr);
        // const result = await this.$http.post('subDelManyCard', this.cardTableArr)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword(1)
        this.getCardTypeSoftName()
        //this.$refs.extractFromRef.resetFields()
        console.log("运行getCardTypeSoftName");
      })
      
    },
    //批量解冻
    batchUnfreeze(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        if (this.batchOperationForm.info.indexOf("*") > -1) {
          this.$notify.error({title: '错误',message:"不能操作不属于自己的卡密"});
          return
        }
        this.state = true
        const result = await this.$http.post('unfreezeMany',this.batchOperationForm)
        //console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
    },
    //批量冻结
    batchFreeze(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        if (this.batchOperationForm.info.indexOf("*") > -1) {
          this.$notify.error({title: '错误',message:"不能操作不属于自己的卡密"});
          return
        }
        this.state = true
        const result = await this.$http.post('freezeMany',this.batchOperationForm)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
    },
    //批量续费
    // batchRenew(){
    //   this.$refs.batchOperationFormRef.validate(async valid => {
    //     if(!valid) return
    //     this.state = true
    //     const result = await this.$http.post('Renew',this.batchOperationForm)
    //     console.log(result);
    //     if(result.data.meta.status !== 200){
    //       this.$notify.error({title: '错误',message:result.data.meta.msg});
    //       return
    //     }
    //     this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
    //     this.state = false
    //     this.batchOperationForm.info = ""
    //     this.batchOperationDialogVisible = false
    //     this.totalStrip = ""
    //     this.$refs.batchOperationFormRef.resetFields()
    //     this.cardTableArr = []
    //     this.$refs.table.clearSelection()
    //     this.batchOperationForm.info = ""
    //     this.getCardPassword()
    //   })
    // },
    //批量续费
    batchRenew(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        if (this.batchOperationForm.info.indexOf("*") > -1) {
          this.$notify.error({title: '错误',message:"不能操作不属于自己的卡密"});
          return
        }
        this.state = true
        const result = await this.$http.post('AgentCardRenew',this.batchOperationForm)
        // const result = await this.$http.post('AgentCardRenew', this.cardTableArr)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
        this.getCardTypeSoftName()
      })
    },
    
    async exports11(){
      //const result = await this.$http.post("download", {email:this.$store.state.account});
      const result = await this.$http.get(`agentdownload/?email=${this.$store.state.account}`,{
        responseType: 'blob',
      });
      let url = window.URL.createObjectURL(new Blob([result.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", this.$store.state.account+".csv");
      document.body.appendChild(link);
      console.log('result',result);
      link.click();
      console.log('result',result);
    },
    async exports() {
      try {
        // 假设你有加载提示，可以在这里开启 (例如 Element UI)
        // this.loading = true; 
        const result = await this.$http.get(`agentdownload/?email=${this.$store.state.account}`, {
          responseType: 'blob', // 【核心】必须设置，否则流数据会被当成乱码字符串处理
        });
        // 1. 明确指定 Blob 的类型为 csv，确保浏览器正确识别
        const blob = new Blob([result.data], { type: 'text/csv;charset=utf-8' });
        // 2. 创建一个指向内部 Blob 对象的 URL (这会占用浏览器内存)
        const url = window.URL.createObjectURL(blob);
        // 3. 创建隐藏的 a 标签并触发点击下载
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        // 设定下载的文件名
        link.setAttribute("download", `${this.$store.state.account}_卡密.csv`); 
        document.body.appendChild(link);
        link.click();
        // 4. 【非常重要】收尾工作：清理 DOM 和释放浏览器内存
        document.body.removeChild(link); 
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载卡密失败:', error);
        // this.$message.error('下载失败，请重试'); // 提示用户
      } finally {
        // this.loading = false; // 关闭加载提示
      }
    },
    //编辑点击事件
    handleClick(index){
      this.editFrom = index
      this.titleCard = ' 编辑卡密:  '+index.cardPassword

      this.editDiaLogVisible = true
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1);
      var day = date.getDate();
      var hours = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month < 10) { month = '0' + month }
      if (day < 10) { day = '0' + day }
      if (hours < 10) { hours = '0' + hours }
      if (minute < 10) { minute = '0' + minute }
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second;
    },
    async keepAlive(){
      this.state = true
      const result = await this.$http.post('update',this.editFrom)
      console.log(result);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.editDiaLogVisible = false
      this.getCardPassword()
    },
    

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.editFrom.device_id.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    //点击提卡的点击事件
    async newCreateCard(){
      this.activeSoftName = {}
      this.extractDialogVisible = true
      //this.extractFrom.softName = this.allSoftName
      //console.log(this.extractFrom.softName);
      //console.log(this.extractFrom.softName);
    },
    //所属软件 选择变化时
    async selectChange(value){
      console.log("----",value);
      let valueArr = value.split('_')
      this.selectIntegral = 0
      this.extractFrom.customUpperLimitNum = 1
      delete this.extractFrom.type
      this.cardTypePrice = []
      let arr = this.extractFrom.softName.split('-')
      console.log('当前的值=',arr[0]);
      this.extractFrom.custom = false
      for (let i = 0; i < this.allSoftNameObj.length; i++) {
        // console.log(this.allSoftNameObj[i].softName);
        // console.log(this.allSoftNameObj[i].softName == arr[0].trim());
        if (this.allSoftNameObj[i].softName == arr[0].trim()) {
          this.activeSoftName = this.allSoftNameObj[i]
          console.log("this.activeSoftName==:",this.activeSoftName);
          break
        }
      }
      // for(let key in this.allSoftNameObj){
      //   for(let keys in this.allSoftNameObj[key]){
      //     // console.log('--',this.allSoftNameObj[key][keys]);
      //     // console.log('==',this.allSoftNameObj[key][keys] === arr[0].trim());
      //     if(this.allSoftNameObj[key][keys] === arr[0].trim()){
      //       this.appKey = this.allSoftNameObj[key]['appKey']
      //     }
      //   }
      // }
      this.appKey = valueArr[1]
      const result = await this.$http.get("getcardtype",{
        params:{
          softName:this.extractFrom.softName,
          email:this.$store.state.account,
          appKey: this.appKey
        }
      });
      // console.log("this.extractFrom.softName=",this.extractFrom.softName);
      
      // console.log('result',result.data.data);
      this.cardTypePrice = result.data.data.map(element => {
        return element.cardName + ' - ' + `[ 消耗:${element.agentPrice}积分/卡 ]`
      })
    },
    closeExtractDiaLog(){
      this.$refs.extractFromRef.resetFields()
      this.extractFrom.customUpperLimitNum = 1;
      this.selectIntegral = 0
    },
    extractBtn(){
      this.$refs.extractFromRef.validate(async valid => {
        if(!valid) return
        this.state = true
        this.extractFrom.email = this.$store.state.account
        this.extractFrom.appKey = this.appKey
        // console.log("this.extractFrom=",this.extractFrom);
        const result = await this.$http.post('createAgentCardPassword',this.extractFrom)
        console.log('提卡-->',result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.extractDialogVisible = false
        //this.getSoftList()
        this.getCardPassword(1)

        this.many = result.data.data.length
        this.copyFrom.cardResult = result.data.data.map(element =>{
          return element.cardPassword
        })
        this.copyFrom.cardResult = this.copyFrom.cardResult.join('\n')
        //this.cardResult = result.data.data.map
        console.log('this.cardResult',this.copyFrom.cardResult);
        //console.log('生成数量:',result.data.data.length);
        this.copyDialog = true
        this.getCardTypeSoftName()
        this.$refs.extractFromRef.resetFields()
      })
    },

    async findChildren(value){
      // if (!value) {
      //   return
      // }
      console.log("查找子代理");
      this.queryInfo.producer = ""
      this.state = true
      const result = await this.$http.post('findchildren', {appKey: value})
      console.log("代理人",result);
      console.log("result.data.data.allChildrenArr-",result.data.data.allChildrenArr);
      
      this.state = false
      if (result.data.meta.status == 200) {
        console.log("进来了");
        this.agentChild = result.data.data.allChildrenArr.map(child => {
          if (child.remarks) {
            // return `${child.level}级-${child.agentEmail}-${child.remarks}`
            return {
              email: `${child.level}级-${child.agentEmail}-${child.remarks}`,
              id: child.id
            }
          }else{
            //return `${child.level}级-${child.agentEmail}`
            return {
              email: `${child.level}级-${child.agentEmail}`,
              id: child.id
            }
          }
        })
        //console.log("this.agentChild-->",this.agentChild);
      }
    },
    clearSoft(){
      this.agentChild = []
      this.$refs.searchFormRef.resetFields()
    },
    onCopy(){
      this.copyDialog = false
      // this.$refs.copyFromRules.resetFields()
      this.$message.success('卡密已复制到剪贴板!')
    },

    async cardPasswordLog(index){
      console.log('index',index);
      if (index.producer != this.$store.state.account) {
        this.$notify.error({title: '错误',message:"不能操作不属于自己的卡密"});
        return
      }
      if(index){
        this.onlineIndex = index
      }
      this.cardTitle = '卡密日志: '+this.onlineIndex.cardPassword
      this.state = true
      const result = await this.$http.get('cardpasswordlog',{
        params: {
          email: this.$store.state.account,
          index: this.onlineIndex,
          queryInfo: this.onlineQueryInfo
        },
      })
      console.log('result-->',result);
      if (result.data.meta.status != 200) {
        this.$notify.error({title: '错误',message: result.data.meta.msg});
        return
      }
      if(result.data.data.resolve){
        if(result.data.data.resolve.length > 0){
          //this.cardData = result.data.data.resolve
          this.cardData = result.data.data.resolve.map(element => {
            if(element.createDate){
              element.createDate = this.timestampToTime(parseInt(element.createDate))
            }
            if(element.sign.indexOf('{') > -1){
              element.sign = JSON.parse(element.sign)
            }else if(element.sign.indexOf('[') > -1){
              element.sign = JSON.parse(element.sign)
            }
            return element
          })
        }
        if(result.data.data.resData){
          this.online = result.data.data.resData
          console.log('this.online',this.online);
          this.totalOnline = this.online.length
        }else{
          this.totalOnline = ""
        }
      }
      this.onlineTotal = result.data.data.total
      this.state = false
      this.cardPassworddialog = true
    },
    async batchUnbind(){
      console.log("this.cardTableArr:", this.cardTableArr.length);
      // console.log("this.cardTableArr:",this.cardTableArr);
      for (let i = 0; i < this.cardTableArr.length; i++) {
        if (this.cardTableArr[i].producer != this.$store.state.account) {
          this.$notify.error({title: '错误',message:"不能操作不属于自己的卡密"});
          return
        }
      }
      if (this.cardTableArr.length > 0) {
        this.state = true
        const result = await this.$http.post('/batchUnbind', this.cardTableArr)
        console.log('批量解绑-->',result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.getCardPassword(1)
      }else{
        this.$notify.error({title: '请选择卡密',message:"请选择需要解绑的卡密"});
        return
      }
    },
    cardRefresh(){
      console.log("触发日志--");
      this.cardPasswordLog(this.onlineIndex)
    },
    onlineHandleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.onlineQueryInfo.pagesize = val
      this.cardPasswordLog()
    },
    // 监听 页码值 改变的事件
    onlineHandleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.onlineQueryInfo.pagenum = val
      this.cardPasswordLog()
    },
    changeInput(e){
      this.$forceUpdate()
    }
  },
  filters:{
    capitalize(value){
      if(Array.isArray(value)){
        value = value.toString()
        value = value.replace('[','')
        value = value.replace(']','')
      }
      return value
    }
  }
};
</script>


<style lang="less" scoped>
.content {
  margin: 5px;
  .el-button{
    margin: 2px 10px;
  }
  .operation{
    margin-left: 10px;
    margin-right: 0px;
  }
  .navbtn{
    margin-bottom: 20px;
  }
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .el-dropdown{
    margin-left: 10px;
    color: #409EFF;
  }
  .el-table{
    .el-button{
      margin-left: 10px;
    }
    td{
      padding: 0 !important;
      height: 30px;
      line-height: 30px;
    }
  }
  .lately{
    margin-top: -3px;
    vertical-align: 1px;
  }

}
.el-badge{
  margin-right: 30px;
}
.custom{
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-top: 6px;
  }
}

.el-tooltip{
  float: left;
  // margin-left: 25px;
}

.batch{
  display: flex;
  justify-content:space-around
}

.datetime{
  margin-left: -58px;
}

.islabel{
  padding-right: 13px;
  margin-left: -11px;
}
.edit-custom{
  margin-left: -44px;
}

.edit-form{
  margin-left: 20px;
}

.crowding{
  margin-left: -45px;
}
.deviceid{
  margin-left: -20px;
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  margin-right: 10px;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  //margin: 0 auto;
  //display: block;
}

.card-log{
  // margin: 0 10px;
  margin-bottom: 20px;
  .el-card{
    border-radius: 7px;
  }
  .el-card__body{
    padding: 10px !important;
  }
}
.el-table{
  .text-record{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
}

.popover-scroll-container {
    /* 设置最大高度，超过此高度将出现滚动条 */
    max-height: 70vh; 
    /* 纵向滚动 */
    overflow-y: auto;
    /* 优化滚动条在移动端或现代浏览器下的体验 */
    overflow-x: hidden;
    padding-right: 5px;
    -webkit-overflow-scrolling: touch;
}

/* 可选：美化滚动条（针对 Webkit 浏览器） */
.popover-scroll-container::-webkit-scrollbar {
    width: 6px;
}
.popover-scroll-container::-webkit-scrollbar-thumb {
    background: #e5e5e5;
    border-radius: 10px;
}
.popover-scroll-container::-webkit-scrollbar-track {
    background: transparent;
}

.token{
  color: #2f54eb;
  background: #f0f5ff;
  border-color: #adc6ff;
}
.cardrefresh{
  margin-right: 10px;
}

.el-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.el-form .el-select{
  width: 80%;
}
/* 隐藏减号按钮 */
.hide-sub ::v-deep .el-input-number__decrease {
  display: none;
}

/* 调整输入框左侧边距，填充隐藏减号后的空白 */
.hide-sub ::v-deep .el-input .el-input__inner {
  padding-left: 15px !important;
}


/* 1. 隐藏加号按钮 */
.only-minus-right ::v-deep .el-input-number__increase {
  display: none !important;
}

/* 2. 将左侧的减号按钮移动并贴紧到右侧 */
.only-minus-right ::v-deep .el-input-number__decrease {
  left: auto !important;
  right: 1px !important;
  border-right: none !important;
  border-left: 1px solid #dcdfe6 !important;
  border-radius: 0 4px 4px 0 !important;
}

/* 3. 调整输入框内边距：左边恢复正常，右边留出按钮位置 */
.only-minus-right ::v-deep .el-input .el-input__inner {
  padding-left: 15px !important;
  padding-right: 50px !important;
}

</style>